import { useContext, useState } from 'react';
import InputField from 'components/common/input-field';
import PrimaryButtom from 'components/common/buttons/primary-btn';
import { emailRegEx } from 'helpers/utils';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as TickIcon } from 'assets/icon/primary-tick.svg';
import { useAppDispatch } from 'hooks/useAppDispatchSelector';
import { forgotPassword } from 'store/features/authSlice';
import toast from 'react-hot-toast';
import { AppContext } from 'context/app-context';
import { ILoginDetails } from 'interfaces/auth-pages-interfaces';
import { useTranslation } from 'react-i18next';

type StepType = 'RESET' | 'SUCCESS';

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const [email, setEmail] = useState<string>('');
  const [step, setStep] = useState<StepType>('RESET');
  const dispatch = useAppDispatch();

  const isValid = () => {
    if (!emailRegEx.test(email)) {
      return false;
    } else {
      return true;
    }
  };
  const handleForgotPassword = () => {
    if (!isValid()) return;
    const request: Pick<ILoginDetails, 'email'> = {
      email: email,
    };
    setLoader(true);
    dispatch(forgotPassword({ request }))
      .then(() => {
        setLoader(false);
        setStep('SUCCESS');
        toast.success(t('FORGOT_PASSWORD_SUCCESS_MESSAGE'));
      })
      .catch(() => {
        setLoader(false);
      });
  };
  const step1 = (
    <div className="flex flex-col items-center w-full gap-y-4">
      <p className="font-medium text-3xl text-center w-full">{t('FORGOT_PASSWORD')}</p>
      <p className="text-base text-center text-grey2 w-full font-regular">
        {t('FORGOT_PASSWORD_SUBTITLE')}
      </p>
      <div className="flex flex-col w-full gap-y-2">
        <p className="text-sm w-full">{t('EMAIL')}</p>
        <InputField
          value={email || ''}
          onChange={(data: string) => setEmail(data)}
          placeholder={t('ENTER_EMAIL')}
          error={
            email.trim() && !emailRegEx.test(email.trim()) ? t('PLEASE_ENTER_VALID_EMAIL') : ''
          }
          disabled={false}
        />
      </div>
      <div className="flex items-center justify-center mt-8">
        <PrimaryButtom
          label={t('SEND_LINK')}
          onClick={() => handleForgotPassword()}
          disabled={!email.trim()}
          width="w-52"
        />
      </div>
    </div>
  );
  const step2 = (
    <div className="flex flex-col items-center w-full gap-y-6">
      <TickIcon />
      <p className="font-bold text-6xl text-center w-full text-primary">{t('SUCCESS')}</p>
      <p className="text-base text-center w-full font-regular">
        {t('FORGOT_PASSWORD_SUCCESS_SUBTITLE')}
      </p>
      <div className="flex items-center justify-center mt-8">
        <PrimaryButtom label={t('BACK_TO_HOME')} onClick={() => navigate('/login')} width="w-52" />
      </div>
    </div>
  );

  return step === 'RESET' ? step1 : step2;
};

export default ForgotPassword;
